import {makeAutoObservable} from 'mobx';
import ScraperConfigAgent from '../agent/scraper-config-agent';
import {ScraperConfigResource} from '../../entity/resource/scraper-config-resource';

export default class ScraperConfigStore {
  scraperConfigAgent: ScraperConfigAgent;

  constructor(scraperConfigAgent: ScraperConfigAgent) {
    makeAutoObservable(this);
    this.scraperConfigAgent = scraperConfigAgent;
  }

  getScraperConfig = async (countyId: string): Promise<ScraperConfigResource | undefined> => {
    try {
      const response = await this.scraperConfigAgent.getScraperConfig(countyId);
      if (response.length > 0 && response[0].isActive)
        return response[0];
    } catch (error: any) {
      console.error('Error occurred while loading the scraper config', error);
    }
  }
}
